export interface UserEntity {
    id: string;
    token: string;
}

export class UserService {
    constructor(private readonly host: string) {}

    async login(token: string): Promise<UserEntity | undefined> {
        localStorage.setItem("token", token);

        return this.getLoggedInUser();
    }

    logout(): Promise<boolean> {
        localStorage.removeItem("token");

        return Promise.resolve(true);
    }

    async getToken(): Promise<string | undefined> {
        return Promise.resolve(localStorage.getItem("token") || undefined);
    }

    async getLoggedInUser(): Promise<UserEntity | undefined> {
        const token = await this.getToken();

        if (!token) {
            return Promise.resolve(undefined);
        }

        return fetch(`${this.host}/me`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        }).then(async (response) => {
            if (response.status === 200) {
                // TinyHacks
                const id = (await response.text()).replace("Hello ", "");
                return { id: id, token: token };
            }
        });
    }
}
